/**
 * 404 Not Found Page
 * Displayed when user navigates to a non-existent route
 */
import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft, Search } from 'lucide-react'

export function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-gold-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-9xl font-bold text-primary opacity-20">404</div>
          <div className="mt-4">
            <Search className="w-24 h-24 text-gray-400 mx-auto" />
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-navy mb-3">Page Not Found</h1>
          <p className="text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for. It might have been moved or
            deleted.
          </p>

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={() => navigate('/')}
              className="w-full bg-primary hover:bg-primary-600 text-white font-semibold py-3 px-4 rounded-md transition-colors flex items-center justify-center space-x-2"
            >
              <Home className="w-5 h-5" />
              <span>Go to Dashboard</span>
            </button>
            <button
              onClick={() => navigate(-1)}
              className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-4 rounded-md transition-colors flex items-center justify-center space-x-2"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Go Back</span>
            </button>
          </div>
        </div>

        {/* Help Text */}
        <p className="text-sm text-gray-500 mt-6">
          Need help? Contact the IT Department or{' '}
          <button
            onClick={() => navigate('/')}
            className="text-primary hover:underline font-medium"
          >
            return to the homepage
          </button>
          .
        </p>
      </div>
    </div>
  )
}

export default NotFound
